

const Loader = () => {
  return (
    <div className='fixed absolute top-0 bottom-0 right-0 left-0 w-screen h-screen overflow-hidden bg-white'>
        <div className='flex justify-center items-center w-full h-full'>
         <div className="flex justify-center">
                <img
                  src="/logo.png"
                  alt="Anthro Care Logo"
                  
                  className="rounded-lg mb-4 mt-4 cursor-pointer animate-pulse w-52"
                 
                />
              </div>
        </div>

    </div>
  )
}

export default Loader